const heroStats = [
  { num: "4+", label: "平台话题覆盖" },
  { num: "12", label: "近期争议热点" },
  { num: "12.6万", label: "热评样本汇总" },
  { num: "15min", label: "更新频次" },
];

const floatingChips = [
  { icon: "ri-fire-line", text: "# 哇偶姐姐直播回应", cls: "bg-primary-500 text-background-50" },
  { icon: "ri-message-3-line", text: "评论区：群嘲 vs 理性", cls: "bg-background-50 text-foreground-900" },
  { icon: "ri-emotion-happy-line", text: "人设？真性情？", cls: "bg-accent-500 text-foreground-950" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-28 md:pt-32">
      {/* decorative blobs */}
      <div
        className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full"
        style={{ background: "oklch(var(--primary-100) / 0.6)" }}
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -bottom-28 -left-20 h-72 w-72 rounded-full"
        style={{ background: "oklch(var(--accent-100) / 0.55)" }}
        aria-hidden="true"
      />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 pb-16 md:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:pb-20">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-background-200 px-3 py-1.5 text-xs text-foreground-700">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-accent-500 text-[11px] text-foreground-950">
              <i className="ri-flashlight-fill" aria-hidden="true" />
            </span>
            围观入口 · 全网风评实时汇总中
          </div>

          <h1 className="font-heading mt-6 text-4xl font-black leading-[1.15] text-foreground-950 md:text-5xl lg:text-[54px]">
            哇偶姐姐
            <span className="mt-2 block">
              风评真相，<span className="text-primary-500">一页看懂</span>
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-[15px] leading-7 text-foreground-700 md:text-base">
            这里是围观<span className="font-semibold text-foreground-950">哇偶姐姐</span>
            全网评价、吐槽与争议的集散地。我们把微博、抖音、小红书、贴吧的热搜话题、评论区画风和风评走向汇总到一起，帮你快速判断大众的真实看法，吃瓜不迷路。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#trend"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-article-line" aria-hidden="true" />
              看实时热搜榜
            </a>
            <a
              href="#comments"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:border-foreground-500 hover:bg-background-100"
            >
              <i className="ri-chat-smile-3-line" aria-hidden="true" />
              围观评论区
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-200 pt-6 sm:grid-cols-4">
            {heroStats.map((s) => (
              <div key={s.label}>
                <dt className="font-bebas text-2xl text-primary-500">{s.num}</dt>
                <dd className="mt-1 text-xs text-foreground-600">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* hero visual */}
        <div className="relative mx-auto w-full max-w-lg lg:max-w-none">
          <div className="relative overflow-hidden rounded-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20collage%20of%20floating%20speech%20and%20comment%20bubbles%20in%20warm%20coral%20red%2C%20golden%20amber%20and%20cream%20paper%20tones%2C%20megaphone%20and%20sound%20wave%20motifs%2C%20fire%20and%20chat%20icons%20scattered%2C%20flat%20modern%20vector%20style%2C%20soft%20grain%20texture%2C%20energetic%20playful%2C%20no%20realistic%20human%20faces%2C%20no%20blue%20purple%20colors&width=900&height=760&seq=waou-hero-visual-001&orientation=portrait"
              alt="哇偶姐姐全网围观与评论话题主题插画"
              className="h-64 w-full object-cover sm:h-80 md:h-[430px] lg:h-[500px]"
            />
            <div
              className="absolute inset-0"
              style={{ background: "linear-gradient(180deg, transparent 55%, oklch(var(--background-950) / 0.45))" }}
              aria-hidden="true"
            />
            <div className="absolute inset-x-0 bottom-0 flex flex-wrap gap-2 p-4 md:p-5">
              {floatingChips.map((c) => (
                <span
                  key={c.text}
                  className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1.5 text-xs ${c.cls}`}
                >
                  <i className={c.icon} aria-hidden="true" />
                  {c.text}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}